import { useTranslation } from 'react-i18next';

import { Label, LABEL_TYPE } from '@/components/generic';

export type ProgressBarProps = {
  progress: number;
  message: string;
  isIndeterminateMode: boolean;
};

const MAIN_CONTAINER_STYLE = 'mt-4 w-full';
const INDETERMINATE_BAR_CONTAINER_STYLE = 'relative h-4 w-full rounded bg-secondary-pale-blue-gray';
const INDETERMINATE_BAR_STYLE =
  'move-progress-bar animate-slideRightLeft absolute left-0 z-10 h-full w-10 rounded bg-secondary-steel-blue';
const CENTER_TEXT_STYLE = 'flex w-full justify-center';
const DETERMINATE_BAR_CONTAINER_STYLE =
  'flex h-4 overflow-hidden rounded-xl bg-secondary-pale-blue-gray';
const DETERMINATE_BAR_STYLE =
  'flex flex-col justify-center whitespace-nowrap bg-secondary-steel-blue text-center text-white shadow-none';
const DETERMINATE_TEXT_STYLE = 'mt-2 flex items-center justify-center text-base';

export const ProgressBar = ({ progress, message, isIndeterminateMode }: ProgressBarProps) => {
  const [t] = useTranslation('common');

  return (
    <div className={MAIN_CONTAINER_STYLE}>
      {isIndeterminateMode ? (
        <>
          <div className={INDETERMINATE_BAR_CONTAINER_STYLE}>
            <div className={INDETERMINATE_BAR_STYLE}></div>
          </div>
          <div className={CENTER_TEXT_STYLE}>
            <Label text={message} type={LABEL_TYPE.H3} />
          </div>
        </>
      ) : (
        <div>
          <div className={DETERMINATE_BAR_CONTAINER_STYLE}>
            <div
              style={{
                width: `${progress}%`
              }}
              className={DETERMINATE_BAR_STYLE}
            />
          </div>
          {progress >= 0 && message && (
            <div className={DETERMINATE_TEXT_STYLE}>
              <Label text={`${message}, ${progress}% ${t('completed')}`} type={LABEL_TYPE.H3} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
